// Import the EventBus.
import { EventBus } from '../plugins/event-bus.js'
import { mapActions } from 'vuex'

export const websiteSettings = {
  methods: {
    ...mapActions({
      dispatchSetWebsiteSettings: 'shared/dispatchSetWebsiteSettings',
    }),
  },

  mounted() {
    // Reload the latest settings
    EventBus.$on('reloadWebsiteSettings', () => {
      this.dispatchSetWebsiteSettings()
    })
  },
}
